module.exports = __webpack_public_path__ + "img/vlads3.cdd05648.png";